import React, { useEffect, useRef } from "react"
import Widget                       from "./widget"
import Sortable                     from "sortablejs"

const Dashboard = ({ rows, currentDashboard, setCurrentDashboard, availableWidgetDefinitions, dashboardView }) => {
  if (!dashboardView) return

  const containerRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) return
    const sortable = Sortable.create(containerRef.current, {
      animation: 150,
      handle:   ".export-drag-handle",
      onEnd:    evt => {
        if (evt.oldIndex === evt.newIndex) return
        
        setCurrentDashboard(prev => {
          const newOrder = [...prev.widgets]
          const [moved]  = newOrder.splice(evt.oldIndex, 1)
          newOrder.splice(evt.newIndex, 0, moved)
          
          const reordered = newOrder.map((widget, index) => ({
            ...widget,
            order: index + 1
          }))
          
          return {
            ...prev,
            widgets: reordered
          }
        })
      },
    })
    
    return () => sortable.destroy()
  }, [])

  const updateWidgetWidth = (widgetId, newWidth) => {
    const updated = currentDashboard.widgets.map(widget =>
      widget.identifier === widgetId ? { ...widget, width: newWidth } : widget
    )
    setCurrentDashboard(prev => ({
      ...prev,
      widgets: updated
    }))
  }

  const getWidthClass = width => {
    switch (width) {
      case 2:  return "w-66"
      case 3:  return "w-100"
      default: return "w-33"
    }
  }

  return (
    <div
      className = "dashboard d-flex w-100 f-wrap pb-6 gap-4"
      ref       = {containerRef}
    >
      {currentDashboard?.widgets?.map(widget => {
        return (
          <div 
            key       = {widget.identifier} 
            className = {`widget-wrapper my-6 ${getWidthClass(widget.width)}`}
          >
            <Widget 
              widgetId                   = {widget.identifier} 
              availableWidgetDefinitions = {availableWidgetDefinitions}
              rows                       = {rows} 
            />
            <div className = "export-drag-handle no-print">
              <i className = "fas fa-arrows-alt text-gray-900" />
            </div>
            <div className = "pr-3 pt-2 widget-controls no-print">
              <label 
                htmlFor   = {`widget-width-${widget.identifier}`} 
                className = "block text-sm font-medium text-gray-700"
              >
                {I18n.t('export.widgets.width')}
              </label>
              {[1, 2, 3].map(number => (
                <button 
                  key     = {number}
                  onClick = {() => updateWidgetWidth(widget.identifier, number)}
                  className = {`${widget.width === number ? 'btn btn-primary' : 'btn btn-secondary'} btn-sm ml-1`}  
                >
                    {number}
                </button>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default Dashboard